/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookVersionListItemResponseModel from './BookVersionListItemResponseModel';

/**
 * The BookVersionListResponseModel model module.
 * @module model/BookVersionListResponseModel
 * @version v1.0.0
 */
class BookVersionListResponseModel {
    /**
     * Constructs a new <code>BookVersionListResponseModel</code>.
     * @alias module:model/BookVersionListResponseModel
     */
    constructor() { 
        
        BookVersionListResponseModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookVersionListResponseModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookVersionListResponseModel} obj Optional instance to populate.
     * @return {module:model/BookVersionListResponseModel} The populated <code>BookVersionListResponseModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookVersionListResponseModel();

            if (data.hasOwnProperty('books')) {
                obj['books'] = ApiClient.convertToType(data['books'], [BookVersionListItemResponseModel]);
            }
        }
        return obj;
    }


}

/**
 * bookId with version
 * @member {Array.<module:model/BookVersionListItemResponseModel>} books
 */
BookVersionListResponseModel.prototype['books'] = undefined;






export default BookVersionListResponseModel;

